<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import DetailView from "@/components/modals/detail-view";
import appConfig from "../../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import { formatDateToWeb, formatCurrency } from "../../../helpers/date-functions";


export default {
    page: {
        title: "Credit Notes Listing",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Credit Notes Listing",
            items: [
                {
                text: "Credit Notes Listing",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            creditnoteList:[],
            creditNoteId: null,
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            date: '',
            cn_sts: '',
            key_search:'',
            program_id:null,
            programList:null,
            dtKey:0,
           
      
        };
    },

    methods: {
    getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },
        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD')
            }
        },
        formatDateToWeb,
        formatCurrency,

        downloadExcel: function () {
            this.loadingDetail=true;
            const posting_ = {                
                date: this.date,
                cn_sts: this.cn_sts,
                key_search: this.key_search,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL+'export/creditNoteListingExport', posting_, {responseType: 'blob'})
            .then(response => {
                if (response) {
                    
                    console.log(response);
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
   
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Credit Notes Listing.xlsx');
                    document.body.appendChild(fileLink);
   
                    fileLink.click();
                    this.loadingDetail=false;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getCreditNoteListing(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'creditnotes/creditNoteListing')
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.creditnoteList = response.data;
                    console.log(this.creditnoteList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        searchCreditNotesForm(e)
        {
            this.loadingRoles=true,
            e.preventDefault()
            
            const posting_ = {                
                date: this.date,
                cn_sts: this.cn_sts,
                key_search: this.key_search,
            };

            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.post(process.env.VUE_APP_AR_API_BASEURL+'creditnotes/searchCreditNote', posting_)
            .then(response => {
                if (response) {
                    this.creditnoteList = response.data;
                    this.dtKey +=1;
                    console.log(this.creditnoteList);
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });

            this.loadingRoles=false;
        },

        resetForm: function () {
            this.loadingRoles=true; 
            this.date = ''; 
            this.cn_sts = ''; 
            this.key_search = '';
      
            this.getCreditNoteListing();
        }
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
        flatPickr,
        DetailView,
    },

    mounted() {
        this.getCreditNoteListing();
    },
    
};
require("@/assets/css/datatable.css");
</script>
<style>
/* .col-xl-8 {
    flex: 0 0 auto;
    width: 82.66667% !important;
} */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"  v-if="this.role = 1"><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br-->
        <!--div class="d-flex justify-content-end mb-3">
            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br>
        </div-->
        <div class="card">
            <div class="card-body">
                <div class="row g-4 align-items-center">
                    <div class="col-sm">
                        <div>
                            <h5 class="card-title mb-0">Credit Notes Listing</h5>                            
                        </div>
                    </div>                   
                </div>
            </div>
            <div class="card-body border-bottom-dashed border-bottom">
                <form @submit="searchCreditNotesForm">
                <div class="row g-3">
                    <div class="col-xl-6">
                        <div class="search-box">
                            <input type="text" class="form-control search"
                            placeholder="Search for Credit Notes ID, Customer Name, Ref. No" v-model="key_search"/>
                            <i class="ri-search-line search-icon"></i>
                        </div>
                    </div>
                    <div class="col-xl-6 pb-3">
                        <div class="row g-2">
                            <div class="col-sm-12">
                                <div class="search-box"><i class="ri-search-line search-icon"></i>
                                    <flat-pickr v-model="date" placeholder="Select Issue Date" :config="rangeDateconfig"
                                    class="form-control"></flat-pickr>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row g-3">
                    <div class="col-xl-6">
                        <div class="search-box">
                            <select class="form-select mb-3" v-model='cn_sts'>
                                <option value="" selected disabled>Search Status</option>
                                <option value="Yes" selected >Resolved</option>
                                <option value="No" selected >Unresolved</option>
                            </select>
                        </div>
                    </div>
                    <!--div class="col-xl-6 pb-3">
                        <div class="row g-2">
                            <div class="col-sm-12">
                                <div class="search-box"><i class="ri-search-line search-icon"></i>
                                    <flat-pickr v-model="date" placeholder="Select Issue Date" :config="rangeDateconfig"
                                    class="form-control"></flat-pickr>
                                </div>
                            </div>
                        </div>
                    </div-->
                </div>
                <div class="row g-3 justify-content-end">
                    <div class="col-xl-2">
                        <div>
                            <button type="submit" class="btn btn-primary w-100">
                                <i class="ri-equalizer-fill me-2 align-bottom"></i>Search
                            </button>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-2">
                        <div>
                            <button type="button" @click='resetForm' class="btn btn-danger w-100">
                                <i class="ri-refresh-fill me-2 align-bottom"></i>Reset
                            </button>
                        </div>
                    </div>
                </div>
                <!--end row-->
                </form>
            </div>

            <div class="card-header border-bottom-dashed">
                 <div class="row g-3 justify-content-end">
                    <div class="col-xl-2">
                        <div>
                           <router-link class="btn btn-success w-100" to="/ar/credit_notes/create" data-key="t-scrollbar"><i class="ri-add-fill align-middle me-1"></i>Create Credit Note</router-link>
                        </div>
                    </div>
                    <!--end col-->
                    <div class="col-xl-2">
                        <div>
                            <button @click="downloadExcel()" class="btn btn-success w-100"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <!--h6>** Orders data display from {{lastthirtyday()}} to {{currentDate()}}</h6-->
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                <DataTable :options="{lengthChange: false,searching: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                     <thead class="table-secondary">
                                        <tr>
                                            <th>#.</th>          
                                            <th scope="col">ID</th>  
                                            <th scope="col">CN Issue Date</th>         
                                            <th scope="col">Customer Name</th>           
                                            <!-- <th scope="col">Credit Invoice</th>                                        -->
                                            <th scope="col">Amount ({{ this.getCurrency() }})</th>                                                                      
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>                        
                                        <tr v-for="(item, index) in creditnoteList" :key="index" class="content">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ item.credit_notes_no }}</td>
                                            <td>{{ format_date(item.issue_date) }}</td>
                                            <td>
                                                <router-link :to="'/customer/customer-details/'+item.customer_id" class="fw-medium link-secondary">
                                                    {{item.name_as_per_nric}}
                                                </router-link>
                                            </td>                               
                                            <!-- <td v-if="item.ar_invoice === null">-</td>                                         
                                            <td v-else>{{item.ar_invoice.invoice_no}}</td>                                          -->
                                            <td>{{ formatCurrency(item.total_amount) }}</td>                  
                                            <td v-if="item.resolved == 'Yes'"><span class="badge" style="background-color: #0AB39C">Resolved</span></td>
                                            <td v-else><span class="badge" style="background-color: #F06548">Unresolved</span></td> 
                                                                                                           
                                            <td>
                                                <div class="dropdown">
                                                    <button class="btn btn-soft-secondary btn-sm dropdown" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <i class="ri-more-fill align-middle"></i>
                                                    </button>
                                                    <ul class="dropdown-menu dropdown-menu-end">
                                                        <li>
                                                            <span class="dropdown-item" @click="()=> creditNoteId = index" data-bs-toggle="modal" data-bs-target=".bs-example-modal-lg" data-target="#DetailModal">
                                                                <i class="ri-eye-fill align-bottom me-2 text-muted"></i> Credit Note Details
                                                            </span>                                                                                            
                                                            <!-- <router-link class="dropdown-item" :to="''"><i class="ri-eye-fill align-bottom me-2 text-muted"></i> Credit Note Details</router-link> -->
                                                        </li>
                                                        <li class="dropdown-divider"></li>
                                                        <!--li>
                                                            <a class="dropdown-item remove-item-btn" @click="deletedata(item)"><i class="ri-delete-bin-fill align-bottom me-2 text-muted"></i> Delete</a>
                                                        </li-->
                                                    </ul>
                                                </div>
                                            </td>                                
                                        </tr>
                                    </tbody>
                                </DataTable>
                                </div>
                                <DetailView title="Credit Note Detail" >
                                    <div class="col-lg-6">
                                        <p class="text-muted mb-0">Customer Name</p>
                                        <h6 class="mb-0">
                                            {{ creditnoteList[creditNoteId]?.name_as_per_nric }}
                                        </h6>
                                    </div>
                                    <div class="col-lg-6">
                                        <p class="text-muted mb-0">Credit Note ID</p>
                                        <h6 class="mb-0">
                                            {{ creditnoteList[creditNoteId]?.credit_notes_no }}
                                        </h6>
                                    </div>
                                    <div class="col-lg-6">
                                        <p class="text-muted mb-0">Date Issue</p>
                                        <h6 class="mb-0">
                                            {{ formatDateToWeb(creditnoteList[creditNoteId]?.issue_date) }}
                                        </h6>
                                    </div>
                                    <div class="col-lg-6">
                                        <p class="text-muted mb-0">Ref. No</p>
                                        <h6 class="mb-0">
                                            {{ creditnoteList[creditNoteId]?.ar_invoice?.invoice_no }}
                                        </h6>
                                    </div>
                                    
                                    <div class="col-lg-6">
                                        <p class="text-muted mb-0">Status</p>
                                        <h6 class="mb-0">
                                            {{ creditnoteList[creditNoteId]?.resolved === 'Yes' ? 'Resolved' : 'Unresolved' }}
                                        </h6>
                                    </div>
                                    <div class="col-lg-6">
                                        <p class="text-muted mb-0">Total Amount</p>
                                        <h6 class="mb-0">
                                            {{ formatCurrency(creditnoteList[creditNoteId]?.total_amount) }}
                                        </h6>
                                    </div>                                    
                                </DetailView>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>